export default "__VITE_ASSET__DHPPeR0j__"